import {Injectable} from '@angular/core';
import {HttpService} from '../../../../services/http.service';
import {Observable} from 'rxjs';

@Injectable()
export class NonElectronicProposedContractService {
    url = 'non-electronic/procurement-process/@/proposed-contract/@';

    constructor(private httpService: HttpService) {
    }

    index(tenderRevisionId: number): Observable<any[] | any> {
        return this.httpService.get('api/non-electronic/procurement-process/proposed-contract' + '?tender_revision_id=' + tenderRevisionId);
    }

    store(data, params: string[]): Observable<any> {
        return this.httpService.post(`api/${this.prepareUrl(this.url, params)}`, data, {observe: 'response'});
    }

    update(data, params: string[]): Observable<any> {
        return this.httpService.put(`api/${this.prepareUrl(this.url, params)}`, data,
            {observe: 'response'});
    }

    show(tenderRevisionId: number, contractId: number): Observable<any> {
        return this.httpService.get(`api/non-electronic/procurement-process/${tenderRevisionId}/proposed-contract/${contractId}`);
    }

    prepareUrl(url: string, params: string[]) {
        for (const param of params) {
            url = url.replace('@', param === null || param === undefined ? '' : param);
        }
        url = url.replace(/@/g, '');
        return url;
    }

    deleteContract(contractId, type, tenderRevisionId) {
        return this.httpService.delete(`api/non-electronic/procurement-process/proposed-contract/${contractId}/${type}/${tenderRevisionId}`);
    }

    getLots(procurementNumber: string, tenderRevisionId: number) {
        return this.httpService.get(`api/non-electronic/procurement-process/
        ${tenderRevisionId}/proposed-contract/get-lots?procurement_number=${procurementNumber}`);
    }

    getVendorInCaseSingleSource(tenderRevisionId) {
        return this.httpService.get(`api/non-electronic/procurement-process/proposed-contract/get-vendor?tender_revision_id=${tenderRevisionId}`);
    }

    vendorsData(searchData) {
        let searchParam = '';
        for (const key in searchData) {
            if (searchData[key]) {
                searchParam += key + '=' + searchData[key] + '&';
            }
        }
        return this.httpService.get('api/non-electronic/procurement-process/proposed-contract/get-vendor' + '?' + searchParam, {observe: 'response'});
    }

    getParticipants(tenderRevisionId: number): Observable<any> {
        return this.httpService.get(`api/non-electronic/procurement-process/proposed-contract/participants/get/${tenderRevisionId}`);
    }

    storeParticipants(data, tenderRevisionId: string[]): Observable<any> {
        return this.httpService.post(`api/non-electronic/procurement-process/proposed-contract/participants` + '?tender_revision_id=' + tenderRevisionId, data, {observe: 'response'});
    }

    deleteParticipant(participantId) {
        return this.httpService.delete(`api/non-electronic/procurement-process/proposed-contract/participants/${participantId}`);
    }

    deleteAllParticipant(tenderRevisionId) {
        return this.httpService.delete(`api/non-electronic/procurement-process/proposed-contract/participants/delete-all-participants/${tenderRevisionId}`);
    }

}
